import { ReactNode } from 'react';

import {
    BoldText,
    PlaceholderCardDescription,
    PlaceholderCardGrayText,
    PlaceholderCardTitle,
    PlaceholderCardWrapper,
    RedText,
} from './PlaceholderCard.styled';

export type BackgroundColorType = 'default' | 'secondary';

export interface PlaceholderCardProps {
    backgroundColor?: BackgroundColorType;
    children: ReactNode;
    gridSize?: number;
    hidden?: boolean;
    minHeight?: number;
}

export const PlaceholderCard = ({
    backgroundColor,
    children,
    gridSize,
    hidden,
    minHeight,
}: PlaceholderCardProps) => {
    return (
        <PlaceholderCardWrapper
            backgroundColor={backgroundColor}
            gridSize={gridSize}
            hidden={hidden}
            minHeight={minHeight}
        >
            {children}
        </PlaceholderCardWrapper>
    );
};

PlaceholderCard.Title = PlaceholderCardTitle;
PlaceholderCard.Description = PlaceholderCardDescription;
PlaceholderCard.GrayText = PlaceholderCardGrayText;
PlaceholderCard.BoldText = BoldText;
PlaceholderCard.RedText = RedText;
